import React, { useMemo } from 'react';
import TableContainer from 'components/Common/TableContainer';
import { Card, CardBody, CardTitle } from 'reactstrap';

const dummySideEffects = [
  { id: '1', name: 'Nausea', severity: 'Mild' },
  { id: '2', name: 'Rash', severity: 'Moderate' },
];

const SideEffectsTable = () => {
  const columns = useMemo(
    () => [
      { header: 'Name', accessorKey: 'name', enableColumnFilter: false, enableSorting: false },
      {
        header: 'Severity',
        accessorKey: 'severity',
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    [],
  );

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Side Effects</CardTitle>
        <TableContainer
          columns={columns}
          data={dummySideEffects}
          isGlobalFilter={false}
          tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-borderless"
          theadClass="table-light"
          paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
          paginationClass="pagination"
        />
      </CardBody>
    </Card>
  );
};

export default SideEffectsTable;
